"use strict";
/**
 * SITPV (SENASICA) prescriptions mirror — API contracts. GH535 · Paso 10.
 *
 * `sitpv_prescriptions` is a **pure mirror** of the controlled prescriptions (recetas cuantificadas) already issued on the
 * SENASICA portal: nothing of ours lives in it, and the portal is the source of truth. These are
 * the shapes the backend serves to the sync panel. Field names are English camelCase; the raw
 * portal payloads (Spanish, as the API spells them) travel only in `raw` of the detail response.
 *
 * Dates are ISO strings. Date-only values from the portal (issue date, expiration date) are
 * stored as Mexico midnight (`T06:00:00.000Z`), so they must be read in `America/Mexico_City`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
